// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"9759826f","611":"89430d4d"}[chunkId] + ".chunk.css";
};